import PropTypes from 'prop-types';
import React from 'react';

export const MarketHeader = ({ marketName, selectionLabels }) => (
  <div className="market-header">
    <div className="market-header__name">{marketName}</div>
    <div className="market-header__selections">
      {selectionLabels.map(label => (
        <div key={label} className="market-header__result">{label}</div>
      ))}
    </div>
  </div>
);

MarketHeader.propTypes = {
  marketName: PropTypes.string.isRequired,
  selectionLabels: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};

export default MarketHeader;
